import React from 'react'
import styled from 'styled-components'
import { Container, Col, Row } from 'styled-bootstrap-grid'
import { marginBreakpoints, hideBlockAt } from '../../../utils/commonAttrs'
import { graphql } from 'gatsby'

const Card = styled.div`
    ${props => marginBreakpoints(props)}
    ${props => hideBlockAt(props)}
    background-color: ${({ backgroundColor, theme }) =>
      backgroundColor || theme.tokens.space.secondary.regular};
    padding: 30px 15px;
    border: 1px solid ${({ theme }) => theme.tokens.interface.neutral.light};
    border-radius: 3px;
    text-align: center;
    ${({ highlightLine, theme }) =>
      highlightLine
        ? `border-bottom: 5px solid ${theme.tokens.accent.base.primary.light}`
        : ``}
`

export default function FeatureCard({
  marginBottom,
  customBackgroundColor,
  highlightLine,
  children,
  childBlock,
  id,
  hiddenAt,
}) {
  const TheCard = (
    <Card
      id={id}
      marginBottom={marginBottom}
      hiddenAt={hiddenAt}
      backgroundColor={customBackgroundColor}
      highlightLine={highlightLine}
    >
      {children}
    </Card>
  )
  if (childBlock) {
    return TheCard
  }
  return (
    <Container>
      <Row>
        <Col col={12} noGutter={false}>
          {TheCard}
        </Col>
      </Row>
    </Container>
  )
}

export const query = graphql`
  fragment featureCardFields on WPGraphQL_MfblocksFeatureCardBlock {
    name
    attributes {
      id
      marginBottom
      customBackgroundColor
      highlightLine
      hiddenAt
    }
    innerBlocks {
      ...headingFields
      ...paragraphFields
      ...textLinkFields
      ...buttonFields
      ...iconFields
      ...iconFeatureFields
      ...youtubeFields
      ...pressItemFields
      ...hrFields
      ...listFields
      ...nestedColumnsFields
      ...trustpilotFields
    }
  }
`
